import { IManageContact } from './../../Interfaces/IManageContact';
import { AddEditProps } from '../../CustomTypes/Filters'

//Actions
export const addManageContact =()=> {
    return {
       type: 'ADD'
    }
 }
 export const editManageContact = (row:IManageContact) => {
    return {
       type: 'EDIT',
       row:row
    }
 }

 export const removeManageContact = ()=> {
    return {
       type: 'DELETE'
    }
 }
//Actions end

export const initialState:AddEditProps = {
    actionToDisplay:"",
    actionType:"",
    message:"",
    title:"",
    rowData:undefined,
    isTableNeedToDispaly:false
}
//Reducer
export const manageContactReducer = (state = initialState, action:any)=>{
    switch(action.type){
        case "ADD":{
            state.actionToDisplay="Save"
            state.actionType="add"
            state.message="Add"
            state.title="Add"
            sessionStorage.setItem('modalProps', JSON.stringify(state))
            return state
        }
        case "EDIT":{
            state.actionToDisplay="Update"
            state.actionType="edit"
            state.message="Edit"
            state.title="Edit"
            state.rowData=action.row.original
            sessionStorage.setItem('modalProps', JSON.stringify(state))
            return state
        }
        case "REMOVE":{
            state.actionToDisplay="Save"
            state.actionType="add"
            state.message="Add"
            state.title="Add"
            return state
        }
        default :return state
    }
}